export const NAV_LINKS = [
	{
		link: '/',
		linkText: 'Sevices',
	},
	{
		link: '/',
		linkText: 'Work',
	},
	{
		link: '/',
		linkText: 'About',
	},
	{
		link: '/',
		linkText: 'Blog',
	},
	{
		link: '/',
		linkText: 'Contact',
	},
]
